var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPuzzleIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "mdi-puzzle",
  viewBox: "0 0 1055.69 1055.69",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M930.02,502.71h-75.41v-201.08c0-55.8-45.24-100.54-100.54-100.54h-201.08v-75.41c0-69.41-56.27-125.68-125.68-125.68s-125.68,56.27-125.68,125.68v75.41H100.54C45.01,201.08,0,246.1,0,301.63v191.03h75.41c75.41,0,135.73,60.33,135.73,135.73s-60.33,135.73-135.73,135.73H0v191.03c0,55.53,45.01,100.54,100.54,100.54h191.03v-75.41c0-75.41,60.33-135.73,135.73-135.73s135.73,60.33,135.73,135.73v75.41h191.03c55.53,0,100.54-45.01,100.54-100.54v-201.08h75.41c69.41,0,125.68-56.27,125.68-125.68s-56.27-125.68-125.68-125.68ZM724.72,626.7h-391.14c-24.93,0-45.13-23.69-45.13-52.91s20.2-52.91,45.13-52.91h391.14c24.93,0,45.13,23.69,45.13,52.91s-20.2,52.91-45.13,52.91Z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPuzzleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/puzzleIcon.a445b9dc.svg";
export { ForwardRef as ReactComponent };